module.exports = "\r\n\r\n<router-outlet></router-outlet>\r\n\r\n\r\n\r\n\r\n\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app.component.html
 ** module id = 446
 ** module chunks = 0
 **/